import { render, staticRenderFns } from "./CollapseDefault.vue?vue&type=template&id=2a61279d&scoped=true&"
import script from "./CollapseDefault.vue?vue&type=script&lang=js&"
export * from "./CollapseDefault.vue?vue&type=script&lang=js&"
import style0 from "./CollapseDefault.vue?vue&type=style&index=0&id=2a61279d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61279d",
  null
  
)

export default component.exports